import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

import transferTypes from './utils/transferTypes';

type StatusTransferStartedProps = {
  /** The message */
  message: any;
};

export default class StatusTransferStarted extends PureComponent<StatusTransferStartedProps> {
  constructor(props: StatusTransferStartedProps) {
    super(props);
  }

  generateStatusText(
    transfer_type: string | null,
    transfer_target_name: string | null,
  ) {
    const targetName = transfer_target_name ? ` "${transfer_target_name}"` : '';
    return `${transferTypes.getTypeString(transfer_type)}${targetName} started`;
  }

  render() {
    const { message, ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text={this.generateStatusText(
          message.transfer_type,
          message.transfer_target_name,
        )}
      />
    );
  }
}
